import { Box, Typography } from '@mui/material';

const SUBSIDIARY_FIELDS = [
  { key: 'name', label: '', isBold: true },
  { key: 'email', label: 'Email' },
  { key: 'address', label: 'Dirección' },
  { key: 'phone', label: 'Teléfono' },
  { key: 'whatsapp', label: 'Whatsapp' },
];

const getSubsidiaryStyles = ({ isPayment, imageWidth }) => ({
  image: {
    width: { xs: 80, sm: imageWidth },
    maxHeight: { xs: 75, sm: 140 },
    objectFit: 'contain',
    flexShrink: 0,
    marginRight: { xs: 1, sm: isPayment ? 0 : 2 },
    marginLeft: isPayment ? 0 : 2,
  },

  text: {
    fontSize: { xs: 15, sm: isPayment ? 14 : 16 },
    color: '#000',
  },
});

const SubsidiaryDetails = ({ subsidiary, withLogo, imageWidth, isPayment }) => {
  if (!withLogo) return null;

  const styles = getSubsidiaryStyles({ isPayment, imageWidth });

  return (
    <Box display="flex" flexDirection="row" alignItems="center">
      <Box
        component="img"
        src="https://assets.conocecordoba.com.ar/voucher_hotels/Franquicias.jpg"
        alt="Franquicias"
        sx={styles.image}
      />

      <Box display="flex" flexDirection="column" flex={1}>
        {SUBSIDIARY_FIELDS.map(field => {
          const value = subsidiary?.[field.key];
          if (!value) return null;

          let textValue = value;

          if (field.label) {
            const separator = field.isBold ? ' : ' : ':';
            textValue = `${field.label}${separator} ${value}`;
          }

          return (
            <Typography
              key={field.key}
              sx={{
                ...styles.text,
                fontWeight: field.isBold ? 600 : 400,
              }}
            >
              {textValue}
            </Typography>
          );
        })}
      </Box>
    </Box>
  );
};

export default SubsidiaryDetails;
